<template>
  <div>
    <PageWrapper :isLoading="isLoading">
      <template #title> ثبت برنامه زمانی برای {{ computedUserName }} </template>
      <BRow>
        <BCol cols="12">
          <ScheduleForWeeks
            @loading="loading"
            @loaded="loaded"
            weekUniqueText="curWeek"
            :weekDays="weekDays.curWeek"
          >
            <template>
              <h3>هفته جاری</h3>
            </template>
          </ScheduleForWeeks>
        </BCol>
      </BRow>
      <BRow>
        <BCol cols="12">
          <ScheduleForWeeks
            @loading="loading"
            @loaded="loaded"
            weekUniqueText="nextWeek"
            :weekDays="weekDays.nextWeek"
            :isForNextWeek="true"
          >
            <template>
              <h3>هفته آینده</h3>
            </template>
          </ScheduleForWeeks>
        </BCol>
      </BRow>
    </PageWrapper>
    <!-- DSD-670 -->
    <!-- <HomeworkOpenTimeList></HomeworkOpenTimeList> -->
  </div>
</template>

<script>
export default {
  mounted() {
    this.getValidDatesForMasterToSetScheduleIn();
  },
  data() {
    return {
      isLoading: false,
      weekDays: [],
      selectedWeekDay: null,
      masterSchedulePayload: {
        count: 100,
        pageNumber: 1,
        masterUserId: getUserData().user.userId,
        targetDate: null,
        effectJustReserve: false,
      },
      userTimePeriods: [
        {
          startTime: null,
          endTime: null,
        },
      ],
      convertedTimePeriosForApiPayload: [],
      masterPreviousSchedules: null,
      tempSchedule: null,
      weekDaysToSetDatesIn: [],
      weekDayForRepeatSchedule: [],
    };
  },
  methods: {
    loading() {
      this.isLoading = true;
    },
    loaded() {
      this.isLoading = false;
    },
    async getValidDatesForMasterToSetScheduleIn() {
      try {
        this.weekDays = [];
        this.isLoading = true;
        let _this = this;
        let validDatesForMaster = new ValidDatesForMaster(_this);
        await validDatesForMaster.fetch((res) => {
          this.weekDays = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedUserName() {
      if (getUserData() && getUserData().user && getUserData().user.fullName)
        return getUserData().user.fullName;
    },
    isSubmitButtonDisabled() {
      if (this.userTimePeriods && this.userTimePeriods.length > 0) {
        return this.userTimePeriods.some(
          (item) => !item.startTime || !item.endTime
        );
      } else {
        return true;
      }
    },
  },
  components: {
    BRow,
    BCol,
    PageWrapper,
    MasterTimePeriodCard,
    ScheduleForWeeks,
    HomeworkOpenTimeList,
  },
};
import MasterTimePeriodCard from "./MasterTimePeriodCard.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import ScheduleForWeeks from "./ScheduleForWeeks.vue";
import HomeworkOpenTimeList from "@/views/components/Homeworks/HomeworkOpenTimeList.vue";
import { ValidDatesForMaster } from "@/libs/Api/MasterSchedule";
import { getUserData } from "@/auth/utils";
import { BRow, BCol } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 420px) {
  .small-font-size {
    font-size: 0.8rem !important;
  }
}
@media only screen and (min-width: 421px) {
  .small-font-size {
    font-size: 1rem !important;
  }
}
</style>
